<template lang="pug">
  .challenge-row(:class="{'challenge-row__prerequisite': isPrerequisite}")
    .challenge-row__icon(@click="$emit('close')")
      font-awesome-icon(icon="times" regular size="sm")
    .challenge-row__column(v-if="!isPrerequisite" v-show="!isValueUnset")
      .challenge-row__input
        input-creator(
          :label="label"
          :autocompleteEntity="autocompleteEntity"
          :filter="filter"
          :tip="description"
          tip-placement="right"
          :data-type="type"
          :value="value"
          :disabled="isValueUnset || isPrerequisite"
          :class="{'error-input': !isValid}"
          @set-enum-value="setEnumValue"
          @set-range-value="setRangeValue"
          @set-input-value="setInputValue")
      lei-btn.challenge-row__btn(type="cyprus" fill size="sm" :disabled="disabled" @click="save") Save
      .challenge-row__error-container
        p.error.challenge-row__error(v-if="isEmptyFlag") Value is required
        p.error.challenge-row__error(v-else-if="isSameValueFlag") New value cannot equal old
      .challenge-row__period-choice(v-if="isPeriod")
        el-radio(v-model="periodChoice" label="period") Period
        el-radio(v-model="periodChoice" label="start") Start
    p.challenge-row__comment-show(
      v-if="!isPrerequisite"
      @click="showCommentField"
      ) {{`${showComment ? 'Hide' : 'Add'} comment`}}
    comment-input(v-if="showComment" @input="comment=$event" :container="false" :required="isValueUnset")
    template(v-if="isPrerequisite")
      lei-info-label(type="prerequisite" :text="prerequisiteMessage")
</template>
<script>
import InputCreator from '@/components/lei-components/inputs/InputCreator'
import LeiModal from '@/components/lei-components/LeiModal'
import LeiBtn from '@/components/lei-components/LeiBtn'
import { mapState, mapMutations, mapActions, } from 'vuex'
import { SAVE_FIELD, SET_CURRENT_RELATIONSHIP_TYPE, RM_FIELDS, } from '@/store/modules/record/modules/challenge/mutations-types'
import { findFilterById, prepareFilterForChallenge, } from '@/store/modules/search/helpers'
import { getAllowUnsetByPath, getAlternativeInputByPath, getExceptByPath, } from '@/utils/challenge'
import { getLabelForResource, } from '@/utils/resources'
import CommentInput from '@/components/lei-components/inputs/CommentInput'
import moment from 'moment'
import { getFieldIdByPath, } from '@/utils/challenge'
import _ from 'lodash/string'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'


const isArray = (arr) => Array.isArray(arr)
const isObject = (obj) => !isArray(obj) && typeof obj === 'object' && obj !== null

const validateResource = (oldVal, newVal) => {
  if (!oldVal) return oldVal === newVal
  else if (newVal.id && oldVal.id) return newVal.id === oldVal.id
  else if (newVal.code && oldVal.code) return newVal.code === oldVal.code
  else return newVal.code === oldVal
}
const validate = (oldVal, newVal) => oldVal ? oldVal === newVal : !!oldVal === !!newVal

export default {
  components: {
    CommentInput,
    LeiBtn,
    LeiModal,
    InputCreator,
    LeiInfoLabel,
  },
  props: {
    challenge: {
      type: [ Object, ],
      required: true,
      default: () => {},
    },
    parentType: {
      type: [ Object, Boolean, ],
      default: () => {},
    },
    prerequisite: {
      type: [ Boolean, String, ],
      default: false,
    },
  },

  data () {
    return {
      comment: {
        value: '',
        valid: true,
      },
      periodChoice: 'period',
      needAlternative: false,
      isEmptyFlag: false,
      isSameValueFlag: false,
      showComment: false,
      value: '',
      startDate: '',
      endDate: '',
      isValueUnset: false,
    }
  },
  computed: {
    description () {
      return this.challenge.text || {}
    },
    label () {
      return `Propose ${this.challenge.label}`
    },
    type () {
      if (this.challenge.type === 'DATE_RANGE' && this.periodChoice !== 'period') return 'DATE'
      return this.needAlternative ? 'STRING' : this.challenge.type
    },
    isPeriod () {
      return this.challenge.type === 'DATE_RANGE'
    },
    autocompleteEntity () {
      return this.challenge.autocompleteEntity
    },
    jsonPath () {
      return this.challenge.jsonPath
    },
    fieldId () {
      return this.challenge.fieldId
    },
    allowAlternative () {
      return getAlternativeInputByPath(this.jsonPath)
    },
    allowUnset () {
      return this.challenge.oldValue && getAllowUnsetByPath(this.jsonPath)
    },
    exchange () {
      return this.challenge.exchange
    },
    startOldDate () {
      return this.challenge.startDate ? this.challenge.startDate.value : null
    },
    endOldDate () {
      return this.challenge.endDate ? this.challenge.endDate.value : null
    },
    periodType () {
      return this.challenge.periodType ? this.challenge.periodType.value : null
    },
    startJsonPath () {
      return this.challenge.startDate ? this.challenge.startDate.jsonPath : null
    },
    endJsonPath () {
      return this.challenge.endDate ? this.challenge.endDate.jsonPath : null
    },
    except () {
      return getExceptByPath(this.jsonPath)
    },
    rawOldValue () {
      return this.challenge.oldValue
    },
    isValid () {
      return !this.isEmptyFlag && !this.isSameValueFlag
    },
    isPrerequisite () {
      return !!this.prerequisite && !(this.challenge.masterField === 'parentEntity' || this.challenge.masterField === 'reason')

    },
    prerequisiteMessage () {
      if (typeof this.prerequisite === 'string') return this.prerequisite
      return this.parentType.updatedParentType === 'parent' ? 'Exception Reason is required' : `${_.startCase(this.parentType.parent)} Entity is required`
    },

    currentType () {
      return this.parentType.currentParentType
    },
    isSameValue () {
      if (this.isPeriod) {
        if (this.periodChoice === 'period') {
          return this.toFormat(this.endOldDate) === this.toFormat(this.endDate) ||
              this.toFormat(this.startOldDate) === this.toFormat(this.startDate)
        }
        else {
          return this.toFormat(this.startOldDate) === this.toFormat(this.value)
        }
      }
      if (this.autocompleteEntity) return this.rawOldValue.indexOf(this.value) !== -1
      return this.resource
        ? validateResource(this.rawOldValue, this.value)
        : validate(this.rawOldValue, this.value)
    },
    disabled () {
      let valueIsValid = this.isValueUnset || (this.value && !this.isSameValue)
      return !this.comment.valid || !valueIsValid
    },
    oldValue () {
      if (this.resource && isObject(this.rawOldValue)) return getLabelForResource(this.resource, this.rawOldValue)
      else if (isArray(this.rawOldValue)) return this.rawOldValue.join('; ')
      else return this.rawOldValue
    },
    title () {
      return `Challenge: ${this.challenge.title}`
    },
    filter () {
      let filter = findFilterById(this.filters, this.challenge.fieldId)
      if (this.challenge.hardCodeEnum && this.challenge.enum) filter.enum = this.challenge.enum
      return prepareFilterForChallenge({
        filter,
        oldValue: this.challenge.oldValue,
        exceptArray: this.except,
      })
    },
    resource () {
      return this.filter ? this.filter.resource : null
    },
    ...mapState('search', [ 'filters', ]),
  },
  watch: {
    value () {
      if (!this.autocompleteEntity) this.isEmptyFlag = !this.value
      this.isSameValueFlag = this.isSameValue
    },
    needAlternative () {
      this.value = ''
    },
    periodChoice (){
      if (this.periodChoice === 'start'){
        this.value = this.startOldDate
      } else {
        this.value = [ this.startOldDate, this.endOldDate, ]
        this.startDate = this.startOldDate
        this.endDate = this.endOldDate
      }
    },
  },
  created () {
    if (this.startOldDate || this.endOldDate) {
      this.value = [ this.startOldDate, this.endOldDate, ]
      this.startDate = this.startOldDate || ''
      this.endDate = this.endOldDate || ''
    }
  },
  methods: {
    async save () {
      let fieldFormattedForStore = {}
      if (this.isPeriod){
        let fieldsToProcess = [
          {
            value: this.startDate || this.value,
            originValue: this.startOldDate,
            jsonPath: this.startJsonPath,
          },
          {
            value: this.endDate || this.value,
            originValue: this.endOldDate,
            jsonPath: this.endJsonPath,
          },
        ]
        if (this.periodChoice === 'end') await this.processChallengeChanges(fieldsToProcess.splice(1, 1))
        if (this.periodChoice === 'start') await this.processChallengeChanges(fieldsToProcess.splice(0, 1))
        if (this.periodChoice === 'period') await this.processChallengeChanges(fieldsToProcess)
      } else {
        const field = await this.getField(this.exchange || this.fieldId)
        fieldFormattedForStore = {
          original_value: this.challenge.oldValue,
          proposed_value: this.value,
          comment: this.comment.value,
          field: field.xpath,
          jsonPath: this.jsonPath,
        }

        if (this.isValueUnset) {
          fieldFormattedForStore.unsetValue = true
        }

        if (this.challenge.masterField === 'parentEntity' && this.currentType === 'exception') {
          this.removeFields(this.parentType.parent)
          this.setCurrentRelationshipType({
            parentType: this.parentType.parent,
            relationshipType: 'parent',
          })
        } else if (this.challenge.masterField === 'reason' && this.currentType === 'parent') {
          this.removeFields(this.parentType.parent)
          this.setCurrentRelationshipType({
            parentType: this.parentType.parent,
            relationshipType: 'exception',
          })
        }

        this.saveField(fieldFormattedForStore)
      }

      this.$emit('close')
    },

    async processChallengeChanges (fieldsToProcess) {
      for (const fieldToProcess of fieldsToProcess) {
        let { jsonPath, } = fieldToProcess
        let originalValue = fieldToProcess.originValue || null
        let proposedValue = fieldToProcess.value
        const comment = `${this.periodType}: ${this.comment.value}`

        if (proposedValue) {
          const { xpath, } = await this.getField(getFieldIdByPath(jsonPath))
          this.saveField({
            original_value: originalValue,
            proposed_value: this.toFormat(proposedValue),
            comment: comment,
            field: xpath,
            jsonPath: jsonPath,
          })
        }
      }
    },

    setInputValue ({ value, }) {
      this.value = value
    },
    toFormat: (date) => date ? moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD') : date,

    showCommentField (){
      this.showComment = !this.showComment
    },
    setRangeValue ({ value, position, }) {
      if (position === 0) this.startDate = value
      else this.endDate = value
      this.value = [ this.startDate, this.endDate, ]

    },
    setEnumValue ({ value, }) {
      this.value = value
    },

    ...mapMutations('record/challenge', {
      setCurrentRelationshipType: SET_CURRENT_RELATIONSHIP_TYPE,
      saveField: SAVE_FIELD,
      removeFields: RM_FIELDS,
    }),
    ...mapActions('record/challenge', [ 'getField', ]),
  },
}
</script>
<style lang="stylus">
@import "../../../assets/styles/variables.styl"
  .challenge-row
    width 100%
    position relative
    padding 15px 20px
    background-color $default-color-light-3
    &__prerequisite
      padding 0
      margin 0
    &__icon
      position absolute
      height 24px
      width 24px
      justify-content center
      display flex
      color $primary-color
      background $primary-color-light-2
      border-radius 50%
      border 1px solid $primary-color
      align-items center
      top -12px
      right -12px
      &:hover
        background $primary-color
        color $primary-color-light-2
    &__column
      display flex
      justify-content space-between
      position relative
      align-items flex-end
      flex-wrap wrap
    &__input
      flex-grow 1
      margin-right 20px

    &__comment-show
      cursor pointer
      text-decoration underline
      color $primary-color
    &__period-choice
      width 100%
    &__error-container
      min-height 16px
      width 100%

  .description
    text-align justify
    color $default-color
    line-height 1.25

  .alternative-checkbox
    margin-bottom 16px

@media (max-width: $laptop)
  .challenge-row
    &__input
      width 120px

@media (max-width: $tablet)
  .challenge-row
    &__input
      width 100%
      margin 0 0 20px
    &__error-container
      position absolute
      top 63px
      right 0
    &__period-choice
      margin-top 10px

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/ChallengeRow.vue